import { Component, OnInit } from '@angular/core';
declare var $: any;  
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit{

  ngOnInit()  
  { 
    $(document).ready(() => {  
      $(window).scroll(function () {
        if ($(window).width() < 992) {
          if ($(window).scrollTop() > 45) {
            $(".fixed-top").addClass("bg-black-opacity shadow");
          } else {
            $(".fixed-top").removeClass("bg-black-opacity shadow");
          }
        } else {
          if ($(window).scrollTop() > 45) {
            $(".fixed-top").addClass("bg-black-opacity shadow").css("top", 0);
          } else {
            $(".fixed-top").removeClass("bg-black-opacity shadow").css("top", 0);
          }
        }
      });
     });

  }


}
